exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n*, *::before, *::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Helvetica Neue\", Helvetica, \"PingFang SC\", \"Hiragino Sans GB\", \"Microsoft YaHei\", \"\\5FAE\\8F6F\\96C5\\9ED1\", Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\nul, ol {\n  list-style: none; }\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 500;\n  margin-bottom: 20px;\n  margin-top: 8px;\n  color: rgba(0, 0, 0, 0.85); }\n\nh1 {\n  font-size: 30px;\n  line-height: 38px; }\n\nh2 {\n  font-size: 24px;\n  line-height: 32px; }\n\nh3 {\n  font-size: 18px;\n  line-height: 26px; }\n\nh4 {\n  font-size: 14px;\n  line-height: 22px; }\n\na {\n  text-decoration: none;\n  color: #1890ff; }\n\np {\n  margin: 14px 0;\n  line-height: 2em; }\n\nimg {\n  vertical-align: top;\n  border: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/style/Global.scss
// module id = 213
// module chunks = 0